import { render, staticRenderFns } from "./WedConfirmCollection.vue?vue&type=template&id=34a1d7bb&scoped=true"
import script from "./WedConfirmCollection.vue?vue&type=script&lang=js"
export * from "./WedConfirmCollection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34a1d7bb",
  null
  
)

export default component.exports